import * as React from 'react';
import { Link } from 'react-router-dom';

import { BooleanView } from 'src/core/ui/boolean.view';
import { DataTableView, Column } from 'src/core/ui/data-table.view';

interface QuoteProductVisibilityPolicyViewProps extends ComponentViewProps<DataSet<QuoteProductVisibilityPolicySummary>> {
	onItemDoubleClicked: (item?: QuoteProductVisibilityPolicySummary) => any;
}

export class QuoteProductVisisbilityPolicyListView extends React.Component<QuoteProductVisibilityPolicyViewProps, {}> {
	public render() {
		const { model, onItemDoubleClicked, setBusy } = this.props;
		const columns: Column[] = [
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				render: (text, record: QuoteProductVisibilityPolicySummary) => <Link to={`/bookings/quote-product-visibility-policies/${record.id}`}>{text}</Link>,
			},
			{
				key: 'isActive',
				title: 'Is Active',
				dataIndex: 'isActive',
				render: (text, record) => {
					return (
						<BooleanView
							mode="display"
							value={record.isActive} />
					);
				}
			}
		];

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						model={model}
						columns={columns}
						setBusy={setBusy}
						itemDoubleClick={onItemDoubleClicked}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-product-visibility-policies/list/quote-product-visibility-policy-list.view.tsx